import { forwardRef } from 'react';
import { Button, ButtonProps } from '../button/button';

export const EmptyStatePrimaryAction = forwardRef<
  HTMLButtonElement,
  ButtonProps
>(function EmptyStatePrimaryAction(props, ref) {
  return <Button ref={ref} variant="primary" size="small" {...props} />;
});
